import { IAppState } from '../../../AppModulesWrapper';

import { selectIsPromotionPackageSelected } from './selectIsPromotionPackageSelected';
import { selectActiveServiceId } from './selectActiveServiceId';

import { EServiceId } from '../../types/reducers/publishTerms';

export const selectIsIncreaseToMinimalTopBet = (state: IAppState): boolean => {
  const isPromotionPackageSelected = selectIsPromotionPackageSelected(state);
  const activeServiceId = selectActiveServiceId(state);

  return !isPromotionPackageSelected && activeServiceId === EServiceId.top;
};
